import { cn } from './cn';

const sizes = {
  20: 'size-5 text-[8.5px]',
  28: 'size-7 text-[11px]',
  40: 'size-10 text-sm',
} as const;

function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');
}

/** A person: their photo, or two initials on grey. People stay neutral; colour belongs to the service. */
export function Avatar({
  name,
  src,
  size = 28,
  online,
  className,
}: {
  name: string;
  src?: string | null;
  size?: keyof typeof sizes;
  /** Shows the presence dot. Leave undefined when presence is not known for sure. */
  online?: boolean;
  className?: string;
}) {
  return (
    <span
      title={name}
      className={cn(
        'relative inline-grid shrink-0 place-items-center rounded-full border border-crow-line bg-crow-raised font-semibold text-crow-text-2',
        sizes[size],
        className,
      )}
    >
      {src ? (
        // eslint-disable-next-line @next/next/no-img-element -- any URL, sized by the circle
        <img src={src} alt="" className="size-full rounded-full object-cover" />
      ) : (
        <span aria-hidden>{initials(name)}</span>
      )}
      <span className="sr-only">{name}</span>
      {online ? (
        <span className="absolute -right-px -bottom-px size-[30%] rounded-full bg-crow-success ring-2 ring-crow-surface" />
      ) : null}
    </span>
  );
}
